import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './Components/App/App';
import {BrowserRouter} from "react-router-dom";
import { store } from './Redux/store';
import { Provider } from 'react-redux';
import { YMaps } from '@pbe/react-yandex-maps';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <YMaps  query={{ lang: 'ru_RU', apikey: '9a7dcf15-05e4-4375-8919-c2d619dbd1d8'  }} enterprise={true}>
        <App /> 
      </YMaps>
    </BrowserRouter>
  </Provider>
);

